module.exports = __webpack_public_path__ + "static/media/delete-alert.59eac94e.svg";